import * as Yup from 'yup'
import { matchIsValidTel } from 'mui-tel-input'

const mobileRegExp = /^\+[0-9]{1,3}-?[0-9]{4,14}$/

const mobileSchema = Yup.string()
  .nullable()
  .notRequired()
  .matches(mobileRegExp, 'validation-phone-regexp')
  .test('is-valid-tel', 'validation-phone-regexp', (value) => !value || matchIsValidTel(value))

const mobileSchemaRequired = Yup.string()
  .matches(mobileRegExp, 'validation-phone-regexp')
  .test('is-valid-tel', 'validation-phone-regexp', (value) => !value || matchIsValidTel(value))
  .required('validation-required')

export { mobileSchema, mobileSchemaRequired, mobileRegExp }
